import { ExploreBanner } from "@modules/study/explore";
import BannerBox from "@modules/study/explore/components/banner_box";
import { getAssets } from "@unisearch/helpers";
import API from "@unisearch/helpers/api";
import { LayoutMain } from "@unisearch/theme/layout";
import dynamic from "next/dynamic";

const ExploreUniList = dynamic(
  () => import("@modules/study/explore/explore_uni_list"),
  {
    loading: () => "Loading...",
  }
);

const University = ({ topUniData, country_slug }) => {
  const { countryInfo, dataResult } = topUniData;
  return (
    <LayoutMain
      title={countryInfo?.metaTitle}
      metaTitle={countryInfo?.metaTitle}
      metaDescription={countryInfo?.metaDescription}
      metaImage={countryInfo?.src}
      metaUrl={`${process.env.NEXT_PUBLIC_URL}/${country_slug}/university`}
    >
      <ExploreBanner
        title={countryInfo?.metaTitle}
        description={countryInfo?.metaDescription}
      />

      <div style={styles.unilistWrapper}>
        <BannerBox
          image={
            countryInfo?.src ||
            getAssets("assets/images/image_placeholder_big.webp")
          }
          alt={countryInfo?.name}
          title={countryInfo?.name}
          university={countryInfo?.totalUni}
          courses={countryInfo?.totalCourse}
        />
      </div>
      <ExploreUniList topUniData={dataResult} />
    </LayoutMain>
  );
};

export default University;

export async function getServerSideProps({ params }) {
  const { country_slug } = params;
  let props = {
    country_slug: country_slug,
    topUniData: "",
  };

  try {
    const pageDetail = await API.get(
      `/public/university-ranking/top-ranking?countrySlug=${country_slug}`
    );
    if (!pageDetail.error && pageDetail.data) {
      props.topUniData = pageDetail.data;
    } else {
      return {
        redirect: {
          permanent: false,
          destination: "/404",
        },
      };
    }

    return {
      props,
    };
  } catch (err) {
    return {
      props,
    };
  }
}

const styles = {
  unilistWrapper: {
    maxWidth: "1920px",
    marginLeft: "auto",
    marginRight: "auto",
    paddingLeft: "30px",
    paddingRight: "30px",
  },
};
